import styled from "styled-components";

export const PedidosContainer = styled.div`
  padding: 1rem 2px;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
`;